import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { designTokens, baseColors } from "theme";

export const styles = (theme: Theme) => {
	return {
		card: {
			backgroundColor: designTokens.colors.white,
			border: `1px solid ${designTokens.colors.borderCard}`,
			borderRadius: 8,
			padding: theme.spacing(3),
			width: "100%",
			boxSizing: "border-box",
		},
		header: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: theme.spacing(2),
			marginBottom: theme.spacing(3),
		},
		title: {
			fontSize: 18,
			fontWeight: 700,
			color: theme.palette.custom.textPrimary,
		},
		clearButton: {
			flexShrink: 0,
			textTransform: "none",
		},
		section: {
			marginBottom: theme.spacing(3),
		},
		row: {
			marginBottom: theme.spacing(2),
			"&:last-child": {
				marginBottom: 0,
			},
		},
		label: {
			display: "flex",
			alignItems: "center",
			gap: 6,
			marginBottom: 4,
			fontSize: 14,
			color: designTokens.colors.grayDark,
		},
		labelIcon: {
			fontSize: 16,
		},
		labelSeparator: {
			color: designTokens.colors.grayDark,
		},
		value: {
			fontSize: 16,
			lineHeight: "24px",
			color: baseColors.darkCharcoal,
		},
		disclaimer: {
			display: "flex",
			alignItems: "center",
			gap: 6,
			marginTop: 10,
			fontSize: 12,
			fontStyle: "italic",
			color: designTokens.colors.grayDark,
		},
		disclaimerIcon: {
			fontSize: 13,
		},
		// Shared by the empty and load-failure states.
		message: {
			fontSize: 16,
			lineHeight: "24px",
			fontWeight: 400,
			color: theme.palette.custom.textSecondary,
			textAlign: "left",
			textWrap: "pretty",
		},
	} satisfies Record<string, CSSObject>;
};
